import React from 'react';

import CheckIcon from '../components/Icons/Check';

import { CardsProps } from '../types';

import {
  CardContainer,
  Header,
  Activity,
  TimeInfo,
  ButtonContainer,
  Button,
  Icon,
  Infos,
} from './styles';

export const Done: React.FC<CardsProps> = ({
  name,
  activity,
  date,
  time,
  ref,
}) => {
  return (
    <CardContainer ref={ref}>
      <Header className="userName">{name}</Header>
      <Infos>
        <Activity>{activity}</Activity>
        <TimeInfo>{`${date} • ${time}`}</TimeInfo>
      </Infos>
      <ButtonContainer>
        <Button>
          Finalizado
          <Icon>
            <CheckIcon />
          </Icon>
        </Button>
      </ButtonContainer>
    </CardContainer>
  );
};

export default Done;
